import script from "./ArchiveFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveFilter.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveFilter.vue?vue&type=style&index=0&id=befb98fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-befb98fe"]])

export default __exports__